module.exports = __webpack_public_path__ + "media/images/icons/filled/sketch-circle-be942dfd30abbce9ed73b4aeee424fc9.svg";